import * as T from "trunx"
import cn from "classnames"
import { PropsWithChildren } from "react"

export function Tag({ children, className }: PropsWithChildren<{ className?: string }>) {
    return <T.Tag className={cn("blm-tag", className)}>{children}</T.Tag>
}
